import React from "react";
import { motion } from "framer-motion";
import {
    SiJavascript,
    SiPython,
    SiCplusplus,
    SiReact,
    SiNextdotjs,
    SiNodedotjs,
    SiExpress,
    SiTensorflow,
    SiNumpy,
    SiAmazonaws,
    SiHtml5,
    SiCss3,
    SiGit,
    SiLinux,
} from "react-icons/si";

const skills = [
    { name: "Next.js", icon: <SiNextdotjs />, brand: "#e5eaf5" },
    { name: "React", icon: <SiReact />, brand: "#61dafb" },
    { name: "JavaScript", icon: <SiJavascript />, brand: "#f7df1e" },
    { name: "AWS", icon: <SiAmazonaws />, brand: "#ff9900" },
    { name: "Python", icon: <SiPython />, brand: "#4b8bbe" },
    { name: "TensorFlow", icon: <SiTensorflow />, brand: "#ff6f00" },
    { name: "NumPy & Pandas", icon: <SiNumpy />, brand: "#4dabcf" },
    { name: "C / C++", icon: <SiCplusplus />, brand: "#659ad2" },
    { name: "HTML", icon: <SiHtml5 />, brand: "#e34f26" },
    { name: "CSS", icon: <SiCss3 />, brand: "#1572b6" },
    { name: "Git & GitHub", icon: <SiGit />, brand: "#f05032" },
    
];

const Skills = () => {
    return (
        <section className="section" id="skilldiv">
            <motion.h2
                className="section-title"
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6 }}
            >
                <span className="section-number">03.</span> My Toolkit
            </motion.h2>
            <div className="skills-grid">
                {skills.map((skill, i) => (
                    <motion.div
                        key={skill.name}
                        className="skill-tile"
                        style={{ "--brand": skill.brand }}
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.4, delay: i * 0.05 }}
                    >
                        <span className="skill-icon">{skill.icon}</span>
                        <span className="skill-name">{skill.name}</span>
                    </motion.div>
                ))}
            </div>
        </section>
    );
};

export default Skills;
